const saleSignature = (value) => JSON.stringify({
  tiers: (value?.price_tiers || value?.tiers || []).map(({ name, min_qty, price }) => ({ name, min_qty, price })),
  units: (value?.units || []).map(({ name, pieces, price }) => ({ name, pieces, price })),
});

export function refreshCartPrices(cart, products) {
  const catalog = new Map((products || []).map((product) => [product.id, product]));
  const changedNames = new Set();
  let touched = false;
  const items = (cart || []).map((item) => {
    const product = catalog.get(item.product_id);
    if (!product) return item;
    const saleChanged = saleSignature(item) !== saleSignature(product);
    const versionChanged = (item.priceVersion || null) !== (product.price_version || null);
    const costChanged = Number(item.cost || 0) !== Number(product.cost || 0);
    if (!saleChanged && !versionChanged && !costChanged) return item;
    touched = true;
    if (saleChanged) changedNames.add(product.name || item.name);
    const units = product.units || [];
    const unit = item.unit ? units.find((candidate) => candidate.name === item.unit.name) || null : null;
    return {
      ...item,
      tiers: product.price_tiers || [],
      units,
      unit,
      cost: product.cost || 0,
      stock: product.stock,
      priceVersion: product.price_version || null,
      ...(saleChanged ? { manualPrice: null, manualTier: null } : {}),
    };
  });
  return { items: touched ? items : cart, changedNames: Array.from(changedNames) };
}
